import { takeEvery, call, put, delay } from 'redux-saga/effects';
import * as API from 'services/api';
import {
  WEEKS_AND_CINEMAS_REQUESTED, WEEKS_AND_CINEMAS_SUCCEDED,
  WEEKS_AND_CINEMAS_FAILED, GET_FESTIVAL_REQESTED,
  GET_FESTIVAL_SUCCEEDED, GET_FESTIVAL_FAILED,
} from 'consts/actionTypes';

export const host = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:3001/api';

export function* getWeeksAndCinemas() {
  try {
    const data = yield call(API.getData, `${host}/schedule/week`);
    yield put({
      type: WEEKS_AND_CINEMAS_SUCCEDED,
      payload: data,
    });
  } catch (error) {
    yield delay(1000);
    yield put({
      type: WEEKS_AND_CINEMAS_FAILED,
    });
    console.log(error); // eslint-disable-line
  }
}

export function* getFestival(action) {
  try {
    const data = yield call(API.getData, `${host}/schedule/festival/${action.payload.festival}`);
    yield put({
      type: GET_FESTIVAL_SUCCEEDED,
      payload: data,
    });
  } catch (error) {
    yield delay(2000);
    yield put({
      type: GET_FESTIVAL_FAILED,
    });
    console.log(error); // eslint-disable-line
  }
}

export const appSagas = [
  takeEvery(WEEKS_AND_CINEMAS_REQUESTED, getWeeksAndCinemas),
  takeEvery(GET_FESTIVAL_REQESTED, getFestival),
];
